import { axiosInstance, ensureCsrfCookie } from "@/lib/axios";
import { AxiosError, isAxiosError } from "axios";

/**
 * Backend contracts. Login, register, forgot and reset are email based and exist today.
 * ASSUMED (confirm with backend):
 *  - verify OTP: POST /api/verify-otp { email, code }
 *    returns { token? }; without a token the OTP code itself is used as the reset token.
 *  - resend OTP: POST /api/forgot-password { email } again.
 */

export type RegisterInput = {
  name: string;
  email: string;
  phone: string;
  phone_country_code: string;
  gender: "male" | "female";
  password: string;
  password_confirmation: string;
};

export async function login(email: string, password: string) {
  await ensureCsrfCookie();
  await axiosInstance.post("/api/login", { email, password });
}

export async function register(input: RegisterInput) {
  await ensureCsrfCookie();
  await axiosInstance.post("/api/register", input);
}

export async function requestReset(email: string) {
  await ensureCsrfCookie();
  await axiosInstance.post("/api/forgot-password", { email });
}

export async function verifyOtp(email: string, code: string): Promise<{ token: string }> {
  await ensureCsrfCookie();
  const { data } = await axiosInstance.post<{ token?: string } | null>("/api/verify-otp", {
    email,
    code,
  });
  return { token: data?.token ?? code };
}

export async function resetPassword(
  email: string,
  token: string,
  password: string,
  password_confirmation: string,
) {
  await ensureCsrfCookie();
  await axiosInstance.post("/api/password-reset", {
    email,
    token,
    password,
    password_confirmation,
  });
}

export function getServerErrors(error: unknown): Record<string, string[]> {
  if (!isAxiosError(error)) return {};
  return (error as AxiosError<{ errors?: Record<string, string[]> }>).response?.data?.errors ?? {};
}

export function getErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    return (error.response?.data as { message?: string } | undefined)?.message ?? error.message;
  }
  return "Terjadi kesalahan, silakan coba lagi";
}
